/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useRef } from 'react';

import { debounce } from '../../utils/lodashUtils';

export default ({ url, onClose }) => {
  const [imageSize, setImageSize] = useState({ height: '100%', width: '100%' });
  const imageElRef = useRef();

  const handleCloseDialog = (evt) => {
    if (evt.target?.id !== 'image-wrapper--container') return;
    if (onClose) onClose();
  };

  const handleCheckImageSizeDirect = () => {
    const imageElement = imageElRef.current;
    if (!imageElement?.naturalHeight || !imageElement?.naturalWidth) return;

    let isWindowLandscape = true;
    const windowSize = { height: window.innerHeight, width: window.innerWidth };

    if (windowSize.height > windowSize.width) isWindowLandscape = false;

    let imageSizeSetup = { height: 'auto', width: 'auto' };
    if (imageElement.naturalWidth > imageElement.naturalHeight && isWindowLandscape) imageSizeSetup = { height: '100%', width: 'auto' };
    else if (imageElement.naturalWidth < imageElement.naturalHeight && isWindowLandscape) imageSizeSetup = { height: '100%', width: 'auto' };
    else if (imageElement.naturalWidth === imageElement.naturalHeight && isWindowLandscape) imageSizeSetup = { height: '100%', width: 'auto' };
    else if (imageElement.naturalWidth === imageElement.naturalHeight && !isWindowLandscape) imageSizeSetup = { height: 'auto', width: '100%' };
    else if (imageElement.naturalWidth > imageElement.naturalHeight && !isWindowLandscape) imageSizeSetup = { height: 'auto', width: '100%' };
    else if (imageElement.naturalWidth < imageElement.naturalHeight && !isWindowLandscape) imageSizeSetup = { height: '100%', width: 'auto' };

    setImageSize(imageSizeSetup);
  };

  useEffect(() => {
    window.addEventListener('resize', debounce(handleCheckImageSizeDirect, 500));
    return () => {
      window.removeEventListener('resize', debounce(handleCheckImageSizeDirect, 500));
    };
  }, []);

  useEffect(() => {
    if (url) debounce(() => handleCheckImageSizeDirect(), 500)();
  }, [url]);

  return (
    <div
      id="image-wrapper--container"
      onClick={handleCloseDialog}
      style={{ alignItems: 'center', backgroundColor: '#00000000', display: 'flex', height: '100%', justifyContent: 'center', width: '100%' }}>
      <img
        ref={imageElRef}
        onLoad={() => debounce(handleCheckImageSizeDirect, 300)()}
        src={url}
        style={{ height: imageSize.height, maxHeight: '100%', maxWidth: '100%', objectFit: 'contain', width: imageSize.width }}
        alt="resource content"
      />
    </div>
  );
};
